import React from 'react';
import { Link, useOutletContext } from 'react-router-dom';

export default function TeacherLandingHome() {
  const { content, base, openContact } = useOutletContext();
  const h = content.home;

  return (
    <main>
      <section className="tl-wrap tl-hero">
        <div>
          <span className="tl-badge">{h.badge}</span>
          <h1 className="tl-serif tl-h1" style={{ marginTop: '1rem' }}>
            {h.headline}
          </h1>
          <p className="tl-lead">{h.subhead}</p>
          <div className="tl-hero-actions">
            <button type="button" className="tl-btn tl-btn-primary" onClick={openContact}>
              {h.primaryCta}
            </button>
            <Link to={`${base}/courses`} className="tl-btn tl-btn-ghost">
              {h.secondaryCta}
            </Link>
          </div>
        </div>
        <div className="tl-hero-visual">
          <img src={content.images.heroClassroom} alt="" />
          <div className="tl-stat-float">
            <small>{h.successLabel}</small>
            <strong>{h.successValue}</strong>
          </div>
        </div>
      </section>

      <section className="tl-section tl-section-muted">
        <div className="tl-wrap">
          <p className="tl-eyebrow">{h.offerEyebrow}</p>
          <h2 className="tl-serif tl-h2">{h.offerTitle}</h2>
          <div className="tl-grid-3">
            {h.courseCards.map((card) => (
              <article key={card.title} className="tl-courses-card">
                <div className="tl-courses-visual">
                  <span className="tl-courses-badge-float">{card.badge}</span>
                  <img src={card.headerImage} alt="" />
                </div>
                <div className="inner">
                  <p className="tl-card-sub">{card.subtitle}</p>
                  <h3>{card.title}</h3>
                  <p>{card.body}</p>
                  <ul className="tl-meta">
                    {card.meta.map((m) => (
                      <li key={m}>{m}</li>
                    ))}
                  </ul>
                  <p style={{ marginTop: '1rem', marginBottom: 0 }}>
                    <Link to={`${base}/courses`} className="tl-linkish">
                      Дізнатись більше →
                    </Link>
                  </p>
                </div>
              </article>
            ))}
          </div>
        </div>
      </section>

      <section className="tl-section">
        <div className="tl-wrap tl-split">
          <div className="tl-portrait-block">
            <img src={content.images.teacherPortraitHome} alt="" />
            <div className="tl-cert-pill">
              {h.certs.map((c) => (
                <span key={c}>{c}</span>
              ))}
            </div>
          </div>
          <div>
            <p className="tl-eyebrow">{h.aboutEyebrow}</p>
            <h2 className="tl-serif tl-h2">{h.aboutTitle}</h2>
            <p className="tl-lead">{h.aboutBody}</p>
            <div className="tl-stats-row">
              {h.aboutStats.map((s) => (
                <div key={s.label}>
                  <strong>{s.value}</strong>
                  <span>{s.label}</span>
                </div>
              ))}
            </div>
            <Link to={`${base}/about`} className="tl-btn tl-btn-ghost">
              {h.aboutCta} →
            </Link>
          </div>
        </div>
      </section>

      <section className="tl-results tl-results-plain">
        <div className="tl-wrap">
          <p className="tl-eyebrow tl-center">{h.resultsEyebrow}</p>
          <h2 className="tl-serif tl-h2 tl-center">{h.resultsTitle}</h2>
          <div className="tl-grid-3" style={{ marginTop: '2rem' }}>
            {h.testimonials.map((t) => (
              <article key={t.name} className="tl-testimonial tl-testimonial-light">
                <div>
                  <span className="tl-score">{t.score}</span>
                  <span className="tl-exam">{t.exam}</span>
                </div>
                <blockquote>“{t.quote}”</blockquote>
                <footer>
                  {t.name}
                  <span>{t.detail}</span>
                </footer>
              </article>
            ))}
          </div>
        </div>
      </section>

      <section className="tl-section">
        <div className="tl-wrap tl-ready">
          <div>
            <h2 className="tl-serif tl-h2">{h.readyTitle}</h2>
            <p className="tl-lead">{h.readyBody}</p>
            <button type="button" className="tl-btn tl-btn-primary" onClick={openContact}>
              {h.readyCta}
            </button>
            <p className="tl-ready-note">{h.readyNote}</p>
          </div>
          <div className="tl-badge-card">
            <span className="corner">IELTS 8.0</span>
            <div className="big">C1</div>
            <div>Cambridge Advanced</div>
          </div>
        </div>
      </section>
    </main>
  );
}
